import { Drawer } from '@mui/material'
import { Button } from '@nextui-org/react'
import { IconPencil, IconX } from '@tabler/icons-react';
import React, { Fragment, useEffect, useState } from 'react'
import Input from './Input';
import Select from './Select';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { generateValidationSchema } from '../utils/validationSchema';
import TooltipContainer from './TooltipContainer';
import TagSelect from './TagSelect';
import authQueries from '../queries/authQueries';
import { useApi } from '../utils/ApiProvider';

const DrawerComponent = ({item, edit, entityForm, inputFields, btnName, header, user}) => {

    const { setApiDataAndNotify } = useApi();

    const [open, setOpen] = useState(false);

    const {handleSubmit, reset, formState: {errors}, register, setValue, getValues} = useForm({
        resolver: yupResolver(generateValidationSchema(inputFields))
    });


    console.log(errors, getValues('roles'))

    useEffect(()=>{
        inputFields?.map((data)=>{
            if(data?.name !== "roles" && data?.name !== "vessels"){
                setValue(data?.name, data?.defaultValue)
            }
        })
    }, [open])

    const viewDetails = authQueries.useViewUser(
        (res)=>{
            if(res.success){
                reset(res.data)
                setApiDataAndNotify(new Date())
            }
        }
    )

    const openDrawer =()=>{
        document.body.style.ove1001rflow = 'hidden';
        document.body.style.height = '100vh';
        if(edit && user){
            viewDetails.mutateAsync(item.id)
            setOpen(true);
        }else if(edit && !user){
            reset(item)
            setOpen(true);
        }else{
            reset()
            setOpen(true);
        }
    };

    const closeDrawer =()=>{
        document.body.style.overflow = 'auto';
        document.body.style.height = 'auto';
        setOpen(false);
    };

    const onSubmit = async(data)=>{
        if(edit){
            data.id = item.id
            await entityForm.mutateAsync(data)
        }else{
            await entityForm.mutateAsync(data)
            reset()
        }
        closeDrawer()
    }
    

  return (
    <Fragment>
        {
            edit ? 
            <TooltipContainer color='primary' content={btnName} placement='bottom'>
                <Button isIconOnly onClick={openDrawer} size='sm'>
                    <IconPencil size="16" />
                </Button>
            </TooltipContainer>:
            <Button onClick={openDrawer} className='max-[526px]:w-full h-[40px] px-6 bg-primary text-white rounded-[7px] font-semibold' size='sm'>
                {btnName}
            </Button>
        }
        <Drawer
        open={open}
        anchor='right'
        onClose={()=>closeDrawer()}
        sx={{
        '& .MuiDrawer-paper': {
        width: '400px',
        maxWidth: '400px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        border: 'none',
        zIndex: 9999
        },
        }}
        >
            <div>
                <div className='flex justify-between font-medium items-center px-6 py-4 gap-3 border-b border-[#E6E6E8]'>
                    <h3>{header}</h3>
                    <button onClick={closeDrawer}>
                        <IconX size="20" />
                    </button>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='p-6 text-[12px] flex flex-col gap-[6px]'>
                        {
                            inputFields?.map((item, index)=> {
                                if(item?.type === 'select'){
                                    return (
                                        <Select key={index} register={register} item={item} errors={errors} />
                                    )
                                }else if(item?.type === ''){
                                    return (
                                        <Input key={index} register={register} item={item} errors={errors} />
                                    )
                                }else if(item?.type === 'tag'){
                                    return (
                                        <TagSelect key={index} register={register} item={item} getValues={getValues} setValue={setValue} errors={errors} />
                                    )
                                }else{
                                    return (
                                        <Input key={index} register={register} item={item} errors={errors} />
                                    )
                                }
                            })
                        }
                        <div className='w-full mt-2'>
                            <Button type='submit' className='w-full text-white bg-primary rounded-[7px] font-medium'>Save</Button>
                        </div>
                    </div>
                </form>
            </div>
        </Drawer>
    </Fragment>
  )
}

export default DrawerComponent